 <!-- Back to Top -->
  <button id="scrollToTopBtn" class="btn btn-lg btn-primary btn-lg-square rounded back-to-top" (click)="scrollToTop()">
  &#9650; <!-- Unicode for up arrow -->
</button>
